module.exports = __webpack_public_path__ + "img/logo-256.3f2e9f52.png";